import { SelectorOption } from '@Components/ModalEditWidget/modal-edit-constants';

// Dynamic field access: callers model their entity as a bpm-types interface with no string index
// signature, so the form reads/writes fields by name through a widened record view of this type.
export type FieldValue = string | number | boolean | null | undefined;

export const OverviewFieldType = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
  COLOR: 'color'
} as const;
export type OverviewFieldTypeType = (typeof OverviewFieldType)[keyof typeof OverviewFieldType];

export interface OverviewField {
  field: string;
  label: string;
  type: OverviewFieldTypeType;
  /** Resolved option list — required for SELECT. Pass a creatable field's existing values here too. */
  options?: SelectorOption[];
  /** SELECT only: render as a searchable, creatable combobox (e.g. "pick or type a new group"). */
  creatable?: boolean;
  readOnly?: boolean;
  /** CHECKBOX only: coerce a raw stored value (e.g. 0/1) to a boolean. Defaults to `Boolean(value)`. */
  toChecked?: (value: FieldValue) => boolean;
  /** CHECKBOX only: coerce a checked boolean back to the stored value. Defaults to identity. */
  fromChecked?: (checked: boolean) => FieldValue;
  /** Read-only display only: custom formatting for a non-empty value (e.g. currency). Defaults to
   * `String(value)`. Never applied while editing — the field editor always shows the raw value. */
  format?: (value: FieldValue) => string;
  /** Span every column of the section's grid instead of sharing a row — for long-form fields
   * (TEXTAREA in particular) that would otherwise get squeezed into a single grid cell. */
  fullWidth?: boolean;
}

export interface OverviewSection {
  title: string;
  fields: OverviewField[];
}
